const FAQ = {
  init() {
    FAQ.events();
  },

  events() {
    $('.faq-item__toggle').on('click', (e) => {
      const faq = $(e.currentTarget).closest('.faq-item');

      faq.find('.faq-item__content').slideToggle(200);
      faq.toggleClass('faq-item--open');
    });
  },
};

export default FAQ;
